import React,{Component } from 'react';
import './AdminCouponsEdit.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import AdminEditCoupons from '../Components/AdminEditCoupons/AdminEditCoupons';
import {Link } from 'react-router-dom';
import plusicon from '../../../image/plusicon.svg'
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import moment from 'moment';
import HandleRes from '../../Components/HandleRes/HandleRes';
import icon from '../../../image/promocodeSM.svg'

 
class AdminCouponsEdit extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            search:'',
            name:'',
            amount:Number,
            minorderamount:Number,
            onlyfirstorder:false,
            limit:false,
            limitedtimes:1,
            validfrom: new Date(),
            validuntill: new Date(),
            EndDate:new Date(),
            startDate:new Date(),
        }
        this.handleChangedate = this.handleChangedate.bind(this);
        this.handleChangedate2 = this.handleChangedate2.bind(this);
        this.getCouponbyname = this.getCouponbyname.bind(this);
        this.getCouponbyname()
        this.getpromocodes()
    }

    getpromocodes=()=>{
        const Token =localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getpromocodes`,{
            headers:{
              Authorization:`${Token}`
            }
          }).then(res =>{
            this.setState({
                data: res.data.reverse(),
              })
              }).catch(error=>{
              this.setState({ backEndError:false});
              })

    }
    componentDidUpdate(){
        if(this.state.name !== this.props.match.params.name) {
            this.getCouponbyname()
        }
      
    }
getCouponbyname =()=>{
    const Token =localStorage.getItem("AdminTokenKayn")
const name = this.props.match.params.name
    axios.get(`${LinkAPI}/api/admin/getpromocode/${name}`,{
        headers:{
        Authorization:`${Token}`
        }
    }).then(res =>{
        this.setState({
                name:res.data.name,
                amount:res.data.amount,
                minorderamount:res.data.minorderamount,
                onlyfirstorder:res.data.onlyfirstorder,
                limitedtimes:res.data.limitedtimes,
                validfrom: res.data.validfrom,
                validuntill: res.data.validuntill,
                EndDate: moment(res.data.validuntill).toDate(),
                startDate: moment(res.data.validfrom).toDate(),
        })
        if(res.data.limitedtimes!==0){
            this.setState({
                limit:true
                
        })
        }else{
            this.setState({
                limit:false
                
        }) 
        }
        }).catch(error=>{
        this.setState({ backEndError:false});
        })
}


handleChangedate(date) {
    let datenew = moment(date).format()
    this.setState({
        validfrom: datenew,
        startDate: date
    });  

}
handleChangedate2(date) {
    let datenew = moment(date).format()
    this.setState({
        validuntill: datenew,
        EndDate: date
    });
    
}
    onlyfirstorder =()=>{
        this.setState({ 
            onlyfirstorder:true,
            limit:false,
            limitedtimes:1,

        });

    }
    limitedtimes =()=>{
        this.setState({ 
            onlyfirstorder:false,
            limit:true
        });

    }

    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("AdminTokenKayn")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message,
                nameError :'',
                amountError :'',
                limitedtimesError :'',
                limitorfirstError:'',
                minorderamountError:'',
                dateError :'',
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }

handleChange = (event) => {
    this.setState({
        [event.target.name]: event.target.value
    });
};
validate= () => {
    let nameError = "";
    let amountError = "";
    let limitedtimesError = "";
    let limitorfirstError = "";
    let minorderamountError="";
    let dateError="";

    if (this.state.name.length < 2 || !isNaN(this.state.name)) {
        nameError = "write account name";
    }
    if (this.state.amount <= 0 || isNaN(this.state.amount)) {
        amountError = "wrong amount  ";
    }
    
    if (this.state.minorderamount <= 0 || isNaN(this.state.minorderamount)) {
        minorderamountError = " wrong Min order amount ";
    }
    if (this.state.onlyfirstorder===false&&this.state.limitedtimes <1||this.state.onlyfirstorder===false&& isNaN(this.state.limitedtimes)) {
        limitedtimesError = "wrong limited times  ";
    }
    if ( moment(this.state.validfrom ).format('L') >=    moment(this.state.validuntill).format('L') ) {
        dateError = " wrong date ";         

    }
    if (isNaN(this.state.amount)) {
        amountError = "write amount";
    }
    if (nameError || amountError ||minorderamountError|| limitedtimesError||limitorfirstError||dateError) {
        this.setState({ nameError, amountError, minorderamountError,limitedtimesError,limitorfirstError,dateError });
        return false;
    }
    return true;
};
EditCoupon = event => {
    event.preventDefault();
    const namex = this.props.match.params.name
    const { name, amount,minorderamount,onlyfirstorder,limitedtimes,validfrom, validuntill } = this.state
    const Token = localStorage.getItem("AdminTokenKayn")
    const isValid = this.validate();
    if (isValid) {
        axios.put(`${LinkAPI}/api/admin/editpromocode/${namex}  `, {
            
                name:name,
                amount:amount,
                minorderamount:minorderamount,
                onlyfirstorder:onlyfirstorder,
                limitedtimes:limitedtimes,
                validfrom:validfrom,
                validuntill:validuntill
           
         }, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            
            this.setState({
                res_doneEdit: true,
                nameError :'',
                amountError :'',
                limitedtimesError :'',
                limitorfirstError:'',
                minorderamountError:'',
                dateError :'',
            })
            this.getpromocodes()
            setTimeout(() => {
                this.setState({
                    res_doneEdit: false
                })
            }, 2000);
        }).catch(error => {
            this.HandleError(error)

        })
    }
}


handleDeleteCoupon = event => {
    event.preventDefault();
    const namex = this.props.match.params.name
    const Token = localStorage.getItem("AdminTokenKayn")
    axios.delete(`${LinkAPI}/api/admin/deletepromocode/${namex}`, {
        headers: {
            Authorization: `${Token}`
        }
    }
    ).then(res => {
        // window.location.replace("/Admin/Coupons")
        this.props.history.push("/Admin/Coupons")
    }).catch(error => {
        this.HandleError(error)
    })
}
    render(){
        let  filteredContantsname = this.state.data.filter(
            (contact)=>{
                return contact.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        const itemdatatabel = filteredContantsname.map((x, i) => {
            return <div  className={" border-bottom item-table pointer " + (this.state.name === x.name ? 'active' : '')} key={i} >
                <Link to={"/Admin/Coupons/Edit/"+x.name} className="d-block p-3"><img className="mr-3" src={icon} alt="user kayn" /><span>{x.name}</span></Link>

            </div>
            
        })
        return( 
            <div>
                <div className="row AppEN  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminCouponsEdit Admin col-md-11 px-4">
                    <AdminHeaderTool/>
                        <h3 className=" fontsize9 my-0 order-8 order-md-2">Coupons</h3>
                    <div className="row">
                                
                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                   <AdminTableDetails itemdatatabel={itemdatatabel} state={this.state} handleChange={this.handleChange} />
                                   <div className="createDiv p-2 text-center">
                                        <Link to="/Admin/Coupons"><button className="text-white badge-pill p-2 pl-1 px-4 border shadow bluebg text-center "><img className="mr-2 " src={plusicon} alt="" />CREATE</button>
                                        </Link>
                                    </div>

                            </div>
                            <div className="col-md-8 px-4 py-3 order-5"> 
                                    <div className="picbg">
                                        <AdminEditCoupons  state={this.state} handleDeleteCoupon={this.handleDeleteCoupon} EditCoupon={this.EditCoupon} CreateCoupon={this.CreateCoupon} handleChange={this.handleChange} handleChangedate={this.handleChangedate} handleChangedate2={this.handleChangedate2} onlyfirstorder={this.onlyfirstorder} limitedtimes={this.limitedtimes}/>
                                    </div>
                            </div>
                            </div>

                    </div>
                </div>
                {(this.state.res_doneEdit ? <HandleRes title="Coupon Edit successfully" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminCouponsEdit;